import { Box, Typography } from "@mui/material";
import HomePage from "./page";

export default function App() {
  return (
    <Box>
      <HomePage />
    </Box>
  );
}
